import { render, staticRenderFns } from "./WizardAddSkill.vue?vue&type=template&id=0f16dedb&scoped=true&"
import script from "./WizardAddSkill.vue?vue&type=script&lang=js&"
export * from "./WizardAddSkill.vue?vue&type=script&lang=js&"
import style0 from "./WizardAddSkill.vue?vue&type=style&index=0&id=0f16dedb&prod&lang=css&"
import style1 from "./WizardAddSkill.vue?vue&type=style&index=1&id=0f16dedb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16dedb",
  null
  
)

export default component.exports